module.exports = __webpack_public_path__ + "media/images/dots-bg-be42df24bec81f8779f7995c043aa3df.png";